<template>
    <v-card class="pa-2">
        <v-card-title class="headline px-2"
            >{{ track ? "Update" : "New" }} Track</v-card-title
        >
        <div class="pa-3">
            <v-select
                class="mb-4"
                :items="getTrackTypes()"
                label="Type"
                v-model="trackType"
                :rules="required"
                ref="trackType"
                hide-details
            ></v-select>
            <v-text-field
                class="mb-4"
                hide-details
                label="Details"
                v-model="data"
                ref="data"
                :rules="required"
            ></v-text-field>
        </div>
        <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn dark color="default" @click="closeDialog()">Cancel</v-btn>
            <v-btn :loading="processing" color="success" @click="save()">
                Save Track
            </v-btn>
        </v-card-actions>
    </v-card>
</template>
<script>
import moment from "moment";
import { formatCurrency, sum } from "../../utils/helpers.js";

export default {
    props: {
        student: Object,
        reload: Function,
        closeNewTrackDialog: Function,
        getDomain: Function,
        track: Object,
        setup: Object,
        trackSetups: Array
    },
    components: {},
    data() {
        return {
            processing: false,
            trackType: "",
            data: "",

            required: [v => !!v || "Required"]
        };
    },
    async created() {},
    watch: {
        track(newValue, oldValue) {
            if (newValue) {
                this.trackType = this.getTrackType(newValue.code);
                this.data = newValue.data;
            }
        }
    },
    computed: {},
    methods: {
        closeDialog() {
            this.trackType = "";
            this.data = "";

            this.$refs.data.resetValidation();
            this.$refs.trackType.resetValidation();

            this.closeNewTrackDialog();
        },
        getTrackType(code) {
            if (!this.trackSetups) return "";

            const setup = this.trackSetups.find(g => g.code == code);

            return setup.description;
        },
        getTrackCode(type) {
            if (!this.trackSetups) return "";

            const setup = this.trackSetups.find(g => g.description == type);

            return setup.code;
        },
        getTrackTypes() {
            if (!this.trackSetups) return [];

            return this.trackSetups.map(g => g.description);
        },
        validate() {
            return [
                this.$refs.trackType.validate(true),
                this.$refs.data.validate(true)
            ].every(Boolean);
        },
        async save() {
            if (!this.validate()) return;

            const isUpdating = this.track;

            this.processing = true;

            const today = moment().format("YYYY-MM-DD HH:mm:ss");

            try {
                await this.$http.post(
                    this.getDomain() + "/api/purimStudents/addTrack",
                    {
                        trackDetailsID: isUpdating
                            ? this.track.trackDetailsID
                            : 0,
                        year: this.setup.currentYear,
                        enteredOn: isUpdating
                            ? moment(this.track.enteredOn).format(
                                  "YYYY-MM-DD HH:mm:ss"
                              )
                            : today,
                        data: this.data,
                        studentID: this.student.studentID,
                        code: this.getTrackCode(this.trackType),
                        entreredBY: isUpdating
                            ? this.track.entreredBY
                            : this.$store.state.authentication.user,
                        updatedOn: isUpdating ? today : null,
                        updatedBY: isUpdating
                            ? this.$store.state.authentication.user
                            : null
                    }
                );

                this.processing = false;

                this.$notify({
                    text: "Track Saved",
                    group: "notification",
                    type: "success"
                });

                this.closeDialog();

                this.reload();
            } catch (e) {
                this.processing = false;
            }
        }
    }
};
</script>
